module.exports = __webpack_public_path__ + "img/image 11.a77db9bb.png";